import Repository from '../../../Repository';
import { computed } from 'vue';
import store from '@/store';
import { useToast } from 'vue-toastification';

const company = computed(() => store.getters['company/info']);
const toast = useToast();

export default {
	index(params) {
		return Repository.get(`/company/${company.value.id}/admin/group`, { params: params });
	},
	list(params) {
		return Repository.get(`/company/${company.value.id}/admin/group/list`, { params: params });
	},
	store(payload) {
		return Repository.post(`/company/${company.value.id}/admin/group`, payload).then((response) => {
			toast.success(`Grupo creado correctamente.`);
			return response;
		});
	},
	show(id) {
		return Repository.get(`/company/${company.value.id}/admin/group/${id}`);
	},
	update(id, payload) {
		return Repository.put(`/company/${company.value.id}/admin/group/${id}`, payload).then((response) => {
			toast.success(`Grupo actualizado correctamente.`);
			return response;
		});
	},
	destroy(id) {
		return Repository.delete(`/company/${company.value.id}/admin/group/${id}`).then((response) => {
			toast.success(`Grupo eliminado correctamente.`);
			return response;
		});
	}
}